module.exports = __webpack_public_path__ + "static/media/reception1.18622e7a.jpg";